export default {
  baseUrl: {
    // dev: 'https://localhost:44382/api/Backstage/',
    // pro: 'https://www.jiexiong19.cn/api/Backstage/',
    // // pro: 'https://localhost:44382/api/Backstage/',
    // img: 'https://www.jiexiong19.cn/'
    pro: 'https://shop.stek.cn/api/Backstage/',
    // pro: 'https://localhost:44382/api/Backstage/',
    img: 'https://shop.stek.cn/'
  }
}
